import { ChatState } from '@chat/types/ChatTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ChatState = {
  chatRoomId: null,
  chatRoomName: '',
  privateYn: '',
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setChatRoomId: (state, action: PayloadAction<number>) => {
      state.chatRoomId = action.payload;
    },
    setChatRoomName: (state, action: PayloadAction<string>) => {
      state.chatRoomName = action.payload;
    },
    setPrivateYn: (state, action: PayloadAction<string>) => {
      state.privateYn = action.payload;
    },
    clearChatRoom: (state) => {
      state.chatRoomId = null;
      state.chatRoomName = '';
      state.privateYn = '';
    },
  },
});

export const { setChatRoomId, setChatRoomName, setPrivateYn, clearChatRoom } =
  chatSlice.actions;

export default chatSlice.reducer;
